module.exports = __webpack_public_path__ + "img/Frame Circle Smartphone.aa0761ea.webp";